// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"75f49fee","652":"00ce4bec"}[chunkId] + ".1780942303696.chunk.css";
};